import { useRouteError } from "react-router-dom";
import { Typography } from "@mui/material";

export default function ErrorBoundary() {
  let error = useRouteError();
  // console.error(error);

  return (
    <Typography
      align="center"
      variant="h5"
      sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
    >
      مشکلی پیش آمده است 😕
    </Typography>
  );
}
